angular.module('ikeweb.locale').constant('localeConstants', [{
    value: 'da-DK',
    label: 'Dansk'
}, {
    value: 'de-DE',
    label: '‪Deutsch‬'
}, {
    value: 'el-GR',
    label: 'Ελληνικά'
}, {
    value: 'en-US',
    label: 'English'
}, {
    value: 'es-ES',
    label: '‪Español'
}, {
    value: 'fi-FI',
    label: 'Suomi‬'
}, {
    value: 'fr-FR',
    label: 'Français'
}, {
    value: 'it-IT',
    label: '‪Italiano‬'
}, {
    value: 'nl-NL',
    label: 'Nederlands'
}, {
    value: 'nb-NO',
    label: '‪norsk‬'
}, {
    value: 'pl-PL',
    label: '‪polski'
}, {
    value: 'pt-PT',
    label: '‪português'
}, {
    value: 'ru-RU',
    label: '‪Русский‬'
}, {
    value: 'sv-SE',
    label: 'Svenska'
}, {
    value: 'tr-TR',
    label: '‪Türkçe‬'
}]);



//////////////////
// WEBPACK FOOTER
// ./src/client/components/locale/locale.constants.js
// module id = 480
// module chunks = 0